import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { EventsState } from '../../../../../../../store/types';
import ActiveEventHeader from '../headers/active-event-header';
import SingleSessionPages from '../single-session-pages';
import { NavMainItems, NavProfileItems } from "../../../../../../../types/working-model";
import { PATHNAMES } from '../../../../../admin';
import PanelHeader from "../headers/panel-header";
import MainNavigation from "./event-main-nav";
import ProfileMenu from "./event-profile-nav";
import EventHomePanel from "./submenus/event-home-panel";
import SessionsList from "./submenus/sessions-panel";
import SessionPanel from "../../../../session/navigation/panel/session-panel";
// import SocialSharing from './social-sharing';
import FaviconUpload from './favicon-upload';
export default function EventPanel(): JSX.Element {
	const {
		CreateEventReducer: {
			workingEvent
		},
	} = useSelector((state: EventsState) => state);

	return (
		<div className="event-panel-container">

			<Switch>
				<Route path={PATHNAMES.Event.HomePath} >
					<ActiveEventHeader title={NavMainItems.Home} />
					<EventHomePanel />
				</Route>
				<Route path={PATHNAMES.Event.SessionsPath} >
					<SessionsList />
				</Route>
				<Route path={PATHNAMES.SessionBasePath} >
					<ActiveEventHeader title={NavMainItems.Sessions} />
					<SessionPanel />
				</Route>
				<Route path={PATHNAMES.Event.TermsConditionsPath}>
					<ActiveEventHeader title={NavProfileItems.TermsAndConditions} />
				</Route>
				<Route path={PATHNAMES.Event.PrivacyPolicyPath}>
					<ActiveEventHeader title={NavProfileItems.PrivacyPolicy} />
				</Route>
				<Route>
					<PanelHeader title="Event" />
					<div className="panel-body">
						{workingEvent?.sessions.length === 1 ? (
							<SingleSessionPages sessions={workingEvent?.sessions ?? []} />
						) : (
							<MainNavigation />
						)}
						<ProfileMenu />
						<FaviconUpload />
						{/* keeping around for when it's needed again */}
						{/* <SocialSharing /> */}
					</div>

				</Route>
			</Switch>
		</div>
	);
}
